import { ExpressCardState } from '@shared/data-access/interfaces';

export class ExpressCardStatusChangeModel {
  // string, not CheckoutCardKey: that type lives in scope:checkout, which scope:cart-checkout
  // may not depend on (Nx module boundaries). The sole caller always passes change.card (a string).
  card?: string;
  map: Map<string, ExpressCardState>;

  constructor(args: Partial<ExpressCardStatusChangeModel> = {}) {
    this.card = args.card;
    this.map = args.map || new Map<string, ExpressCardState>();
  }
}
